var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 322.836,
    height: 308.002,
    viewBox: "0 0 322.836 308.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "translate(-1303.083 -194.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5395",
    "data-name": "Group 5395",
    transform: "translate(1177.508 99.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5393",
    "data-name": "Group 5393",
    transform: "translate(125.575 125.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M175,365.3s.417,57.594,53.838,77.209c0,0,41.735,17.946,83.47-24.624,0,0,40.9,41.317,79.3-11.268,0,0,32.97,17.111,52.168-18.781,0,0,15.442-30.884-10.016-50.082,0,0,15.859-27.962.835-58.011,0,0-10.016-22.954-35.475-29.214,0,0-2.087-56.342-53.421-76.375,0,0-76.792-29.632-107.676,56.759,0,0-54.255-20.033-75.123,45.491,0,0-45.908,6.678-35.892,57.594C127,334,135.769,369.47,175,365.3Z",
    transform: "translate(-125.575 -169.246)",
    fill: "#c2eed3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M179.252,371.756l106.006,75.957L361.633,368H178Z",
    transform: "translate(-156.121 -285.05)",
    fill: "#36c96d",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M377.827,494.886h-173.4a9.536,9.536,0,0,1-9.285-7.289l-28.16-115.27a9.558,9.558,0,0,1,9.285-11.826H350.793a9.52,9.52,0,0,1,9.305,7.375l27.034,115.27a9.558,9.558,0,0,1-9.306,11.74ZM176.268,366.76a3.3,3.3,0,0,0-3.2,4.08l28.16,115.27a3.29,3.29,0,0,0,3.2,2.515h173.4a3.3,3.3,0,0,0,3.211-4.051L354,369.305a3.285,3.285,0,0,0-3.21-2.545Z",
    transform: "translate(-149.54 -280.681)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M282.53,448.127a10.462,10.462,0,0,1-6.1-1.947l-103.294-73.9,3.642-5.091,103.294,73.9a4.271,4.271,0,0,0,5.552-.526l70.7-74.234,4.533,4.317-70.7,74.234A10.521,10.521,0,0,1,282.53,448.127Z",
    transform: "translate(-153.287 -284.076)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-2.913,42.186a2.08,2.08,0,0,1-1.46-.6,2.087,2.087,0,0,1-.03-2.951L37.735-4.374a2.087,2.087,0,0,1,2.951-.03,2.087,2.087,0,0,1,.03,2.951L-1.423,41.559A2.08,2.08,0,0,1-2.913,42.186Z",
    transform: "translate(67.369 151.791)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M59.687,44.247a2.077,2.077,0,0,1-1.218-.393L-4.133-1.22a2.087,2.087,0,0,1-.474-2.913,2.087,2.087,0,0,1,2.913-.474l62.6,45.074a2.087,2.087,0,0,1-1.221,3.78Z",
    transform: "translate(149.997 150.135)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M394.4,517.745H231.658a7.921,7.921,0,0,1-7.725-6.089l-21.876-91.083a2.087,2.087,0,1,1,4.058-.975l21.876,91.082a3.761,3.761,0,0,0,3.667,2.891H394.4a2.087,2.087,0,1,1,0,4.173Z",
    transform: "translate(-170.104 -314.182)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M29.892-.992H-3.5A2.5,2.5,0,0,1-6-3.5,2.5,2.5,0,0,1-3.5-6H29.892a2.5,2.5,0,0,1,2.5,2.5A2.5,2.5,0,0,1,29.892-.992Z",
    transform: "translate(245.318 197.251)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M16.119-.992H-3.5A2.5,2.5,0,0,1-6-3.5,2.5,2.5,0,0,1-3.5-6H16.119a2.5,2.5,0,0,1,2.5,2.5A2.5,2.5,0,0,1,16.119-.992Z",
    transform: "translate(240.518 174.715)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M17.371-.992H-3.5A2.5,2.5,0,0,1-6-3.5,2.5,2.5,0,0,1-3.5-6H17.371a2.5,2.5,0,0,1,2.5,2.5A2.5,2.5,0,0,1,17.371-.992Z",
    transform: "translate(233.006 126.302)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M29.892-.992H-3.5A2.5,2.5,0,0,1-6-3.5,2.5,2.5,0,0,1-3.5-6H29.892a2.5,2.5,0,0,1,2.5,2.5A2.5,2.5,0,0,1,29.892-.992Z",
    transform: "translate(224.45 103.765)",
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5394",
    "data-name": "Group 5394",
    transform: "translate(238.854 95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M403,102.417l12.52,32.97,1.669-7.93.524-10.857,20.344-.829L403,102Z",
    transform: "translate(-400.496 -99.079)",
    fill: "#36c96d",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M435.788,191.924a1.669,1.669,0,0,1-1.539-1.022L412.13,138.316a1.669,1.669,0,1,1,3.078-1.295l20.573,48.91,4.727-11.344a1.669,1.669,0,1,1,3.082,1.284l-6.26,15.025a1.669,1.669,0,0,1-1.538,1.027Z",
    transform: "translate(-405.739 -118.888)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M487.668,177.632a1.67,1.67,0,0,1-1.538-2.318l3.339-7.93a1.669,1.669,0,0,1,.938-.91l25.421-9.805-12.549-5.47a1.669,1.669,0,1,1,1.334-3.061l16.277,7.095a1.669,1.669,0,0,1-.066,3.088l-28.552,11.013-3.063,7.275A1.67,1.67,0,0,1,487.668,177.632Z",
    transform: "translate(-448.855 -125.88)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M446.246,118.372a1.664,1.664,0,0,1-.647-.131L401.573,99.7l2.835,7.655a1.669,1.669,0,0,1-3.131,1.16L397.1,97.249a1.669,1.669,0,0,1,2.213-2.118l47.578,20.033a1.67,1.67,0,0,1-.649,3.208Z",
    transform: "translate(-397 -95)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M18.954,21.041a1.664,1.664,0,0,1-1.192-.5L-3.522-1.162A1.669,1.669,0,0,1-3.5-3.522,1.669,1.669,0,0,1-1.139-3.5L20.146,18.2a1.669,1.669,0,0,1-1.192,2.838Z",
    transform: "translate(4 4)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M12.507,14.39a1.664,1.664,0,0,1-1.189-.5L-3.519-1.159A1.669,1.669,0,0,1-3.5-3.519,1.669,1.669,0,0,1-1.142-3.5L13.7,11.549a1.669,1.669,0,0,1-1.189,2.841Z",
    transform: "translate(29.458 29.876)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M434.669,157.7A1.669,1.669,0,0,1,433,156.035v-22.66a1.669,1.669,0,0,1,1.679-1.669l21.7.123a1.669,1.669,0,0,1-.019,3.339l-20.023-.113v20.981A1.669,1.669,0,0,1,434.669,157.7Z",
    transform: "translate(-417.975 -116.387)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M6.434,8.1a1.664,1.664,0,0,1-1.18-.489L-3.511-1.15a1.669,1.669,0,0,1,0-2.361,1.669,1.669,0,0,1,2.361,0L7.614,5.253A1.669,1.669,0,0,1,6.434,8.1Z",
    transform: "translate(58.255 58.673)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M6.434,8.1a1.664,1.664,0,0,1-1.18-.489L-3.511-1.15a1.669,1.669,0,0,1,0-2.361,1.669,1.669,0,0,1,2.361,0L7.614,5.253A1.669,1.669,0,0,1,6.434,8.1Z",
    transform: "translate(47.404 62.429)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    "data-name": "Line 11",
    d: "M6.434,8.1a1.664,1.664,0,0,1-1.18-.489L-3.511-1.15a1.669,1.669,0,0,1,0-2.361,1.669,1.669,0,0,1,2.361,0L7.614,5.253A1.669,1.669,0,0,1,6.434,8.1Z",
    transform: "translate(62.011 47.822)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M624.649,371.984q-1.064,0-2.06-.018a1.669,1.669,0,1,1,.06-3.338c1.523.027,3.178.026,4.933-.021a1.669,1.669,0,1,1,.089,3.338C626.627,371.972,625.617,371.984,624.649,371.984Zm-7.033-.219q-.053,0-.107,0c-3.191-.2-5.108-.467-5.108-.467a1.669,1.669,0,0,1,.456-3.308c.033,0,1.852.252,4.862.443a1.669,1.669,0,0,1-.1,3.336Zm15.011-.07a1.669,1.669,0,0,1-.121-3.334c1.589-.117,3.228-.277,4.9-.487a1.669,1.669,0,1,1,.418,3.312c-1.728.218-3.424.383-5.069.5C632.709,371.694,632.667,371.7,632.626,371.7Zm9.931-1.264a1.67,1.67,0,0,1-.3-3.311c1.588-.3,3.187-.643,4.782-1.051a1.669,1.669,0,1,1,.828,3.234c-1.667.427-3.339.791-5,1.1A1.681,1.681,0,0,1,642.558,370.431Zm9.693-2.5a1.67,1.67,0,0,1-.538-3.25c1.531-.521,3.043-1.108,4.522-1.766a1.669,1.669,0,0,1,1.359,3.05c-1.571.7-3.178,1.323-4.8,1.877A1.667,1.667,0,0,1,652.25,367.932Zm9.126-4.094a1.67,1.67,0,0,1-.839-3.114,38.986,38.986,0,0,0,4-2.654,1.669,1.669,0,0,1,2.019,2.659,42.341,42.341,0,0,1-4.341,2.883A1.662,1.662,0,0,1,661.376,363.838Zm7.937-6.061a1.669,1.669,0,0,1-1.185-2.845,31.661,31.661,0,0,0,3.087-3.613,1.669,1.669,0,0,1,2.7,1.97,35.022,35.022,0,0,1-3.413,4A1.664,1.664,0,0,1,669.313,357.777Zm5.882-8.057a1.67,1.67,0,0,1-1.481-2.438,32.778,32.778,0,0,0,1.871-4.377,1.669,1.669,0,0,1,3.156,1.089,36.138,36.138,0,0,1-2.063,4.824A1.669,1.669,0,0,1,675.194,349.72Zm3.281-9.431a1.671,1.671,0,0,1-1.638-2,42.453,42.453,0,0,0,.682-4.765,1.669,1.669,0,1,1,3.326.289,45.811,45.811,0,0,1-.736,5.142A1.67,1.67,0,0,1,678.475,340.289Zm.891-9.956a1.669,1.669,0,0,1-1.669-1.652q-.024-2.343-.254-4.865a1.669,1.669,0,0,1,3.325-.306q.245,2.665.268,5.137a1.669,1.669,0,0,1-1.652,1.686Zm-.9-9.975a1.67,1.67,0,0,1-1.644-1.393q-.425-2.53-1.019-4.738a1.669,1.669,0,1,1,3.225-.866q.633,2.357,1.087,5.051a1.671,1.671,0,0,1-1.648,1.946Zm-2.641-9.638a1.67,1.67,0,0,1-1.544-1.033,27.962,27.962,0,0,0-2.146-4.2,1.669,1.669,0,0,1,2.827-1.776,31.31,31.31,0,0,1,2.405,4.705,1.67,1.67,0,0,1-1.543,2.306Zm-5.347-8.4a1.665,1.665,0,0,1-1.2-.511,21.568,21.568,0,0,0-3.564-2.969,1.669,1.669,0,1,1,1.851-2.779,24.911,24.911,0,0,1,4.117,3.43,1.669,1.669,0,0,1-1.2,2.828Zm-8.252-5.555a1.664,1.664,0,0,1-.65-.133,34.374,34.374,0,0,0-4.518-1.53,1.669,1.669,0,1,1,.861-3.226,37.718,37.718,0,0,1,4.959,1.681,1.67,1.67,0,0,1-.652,3.207Zm-9.634-2.648a1.678,1.678,0,0,1-.277-.023c-1.571-.262-3.194-.473-4.863-.648a1.669,1.669,0,1,1,.348-3.321c1.739.182,3.429.4,5.065.675a1.67,1.67,0,0,1-.273,3.316Zm-9.954-1.087q-.058,0-.117,0c-1.624-.113-3.282-.208-4.972-.3a1.669,1.669,0,0,1,.177-3.334c1.708.091,3.385.187,5.026.3a1.669,1.669,0,0,1-.114,3.335Zm-10-.556-.088,0c-1.65-.086-3.324-.177-5.019-.284a1.669,1.669,0,0,1,.211-3.332c1.682.106,3.344.2,4.982.282a1.669,1.669,0,0,1-.085,3.337Zm-9.995-.649q-.071,0-.143-.006-2.495-.212-5.035-.5a1.669,1.669,0,1,1,.386-3.316q2.487.29,4.932.493a1.669,1.669,0,0,1-.14,3.333Zm-9.945-1.172a1.677,1.677,0,0,1-.26-.02q-2.49-.39-5.006-.9a1.669,1.669,0,1,1,.671-3.271q2.437.5,4.852.874a1.67,1.67,0,0,1-.256,3.319Zm-9.808-2.022a1.672,1.672,0,0,1-.423-.055q-2.445-.639-4.9-1.435a1.669,1.669,0,1,1,1.034-3.175q2.359.768,4.71,1.38a1.67,1.67,0,0,1-.421,3.285Zm-9.516-3.107a1.666,1.666,0,0,1-.616-.119q-2.347-.933-4.691-2.047a1.669,1.669,0,0,1,1.437-3.014q2.241,1.068,4.488,1.958a1.67,1.67,0,0,1-.617,3.221Zm-9.035-4.309a1.661,1.661,0,0,1-.817-.215q-2.195-1.235-4.375-2.661a1.669,1.669,0,0,1,1.83-2.792q2.084,1.366,4.183,2.544a1.67,1.67,0,0,1-.82,3.125Zm-8.372-5.484a1.662,1.662,0,0,1-1-.337q-2-1.509-3.98-3.207a1.669,1.669,0,1,1,2.175-2.533q1.9,1.63,3.815,3.074a1.669,1.669,0,0,1-1.007,3Zm-7.6-6.519a1.664,1.664,0,0,1-1.162-.471q-1.79-1.735-3.558-3.65a1.669,1.669,0,1,1,2.455-2.263q1.7,1.845,3.427,3.516a1.669,1.669,0,0,1-1.162,2.868Zm-6.993-7.17a1.664,1.664,0,0,1-1.18-.489l-.706-.706a1.669,1.669,0,1,1,2.361-2.361l.706.706a1.669,1.669,0,0,1-1.18,2.85Z",
    transform: "translate(-491.39 -189.972)",
    fill: "#535353"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    d: "M59.007,43.479,37.483,6.045a8.021,8.021,0,0,0-14.011,0L2.082,43.479A8.021,8.021,0,0,0,8.927,55.591h43.1a8.021,8.021,0,0,0,6.979-12.112Z",
    transform: "translate(1400.52 341.273)",
    fill: "#e27474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7161",
    "data-name": "Path 7161",
    d: "M30.478,39.548a2.674,2.674,0,1,0,2.674,2.674A2.674,2.674,0,0,0,30.478,39.548Zm28.529,3.93L37.483,6.045a8.021,8.021,0,0,0-14.011,0L2.082,43.479A8.021,8.021,0,0,0,8.927,55.591h43.1a8.021,8.021,0,0,0,6.979-12.112Zm-4.626,5.348a2.674,2.674,0,0,1-2.353,1.364H8.927a2.7,2.7,0,0,1-2.353-4.037L27.964,8.719a2.674,2.674,0,0,1,4.759,0L54.247,46.153a2.674,2.674,0,0,1,.134,2.727Zm-23.9-30.669A2.674,2.674,0,0,0,27.8,20.832v10.7a2.674,2.674,0,1,0,5.348,0v-10.7A2.674,2.674,0,0,0,30.478,18.158Z",
    transform: "translate(1400.52 341.273)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    d: "M30.478,39.548a2.674,2.674,0,1,0,2.674,2.674A2.674,2.674,0,0,0,30.478,39.548Zm0-21.39A2.674,2.674,0,0,0,27.8,20.832v10.7a2.674,2.674,0,1,0,5.348,0v-10.7A2.674,2.674,0,0,0,30.478,18.158Z",
    transform: "translate(1400.52 341.273)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpired);
export default __webpack_public_path__ + "static/media/link_expired.c9db5e07b2f06330a1e133bcebe303d3.svg";
export { ForwardRef as ReactComponent };